<template>
  <ul class="ly-header-function-list funcition-list">
    <!-- <li class="funcition-list__item funcition-list__item--search" v-if="iconColor === 'white'">
      <img src="@/assets/icon/header_search.svg" />
    </li> -->

    <li class="funcition-list__item funcition-list__item--user">
      <template v-if="iconColor === 'white'">
        <div class="avatar-path GTM_POINT_header_avatar" :style="{ 'background-image': `url('${avatarPath}')` }"
          @click="toMmeberPage"></div>
      </template>
      <template v-else>
        <div class="avatar-path GTM_POINT_header_avatar" :style="{ 'background-image': `url('${avatarPath}')` }"
          @click="toMmeberPage"></div>
      </template>

      <span class="funcition-list__item__sign-in GTM_POINT_header_sign-in"
        :class="`funcition-list__item__sign-in--${iconColor}`" @click="handleClick">{{ isLogin ? 'SIGN OUT' : 'SIGN IN'
        }}</span>
    </li>

    <li class="funcition-list__item funcition-list__item--language">
      <language :iconColor="iconColor" />
    </li>
  </ul>
</template>
<script>
import { defineComponent, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useSiteStore } from '@/store/site';
import Language from '@/components/Layout/Language/index.vue';
import imageSource from '@/utils/imageSource';
import avatarDefaultImg from '@/assets/icon/header_user.svg';
import blackAvatarDefaultImg from '@/assets/icon/header_user_black.svg';
import usePopInfo from '@/hooks/usePopInfo';

export default defineComponent({
  name: 'MenuFunctionList',
  components: {
    Language,
  },
  props: {
    iconColor: {
      type: String,
      default: 'white',
    },
  },
  setup(props) {
    const siteStore = useSiteStore();
    const router = useRouter();
    const { t } = useI18n();
    const { successPopInfo } = usePopInfo();

    const isLogin = computed(() => siteStore.isLogin);
    const avatarPath = computed(() => {
      const defaultAvatar = props.iconColor === 'white' ? avatarDefaultImg : blackAvatarDefaultImg;

      return imageSource(siteStore.memberInfo.avator, defaultAvatar);
    });

    const handleLogout = () => {
      siteStore.handleLogout();
      window.location = '/';
    };

    const handleLogoutConfirm = async () => {
      successPopInfo({
        desc: t('msg.logoutConfirm'),
        callback: handleLogout,
        showClose: true,
      });
    };

    const handleClick = () => {
      if (isLogin.value) {
        handleLogoutConfirm();
      } else {
        router.push({ name: 'sign-in' });
      }
    };

    const toMmeberPage = () => {
      if (isLogin.value) {
        router.push({ name: 'my-profile-personal-details' });
      } else {
        router.push({ name: 'sign-in' });
      }
    };

    return {
      handleClick,
      isLogin,
      toMmeberPage,
      avatarPath,
      avatarDefaultImg,
      blackAvatarDefaultImg,
    };
  },
});
</script>
<style lang="scss" scoped>
.funcition-list {
  @include flex();

  &__item {
    cursor: pointer;

    &--search {}

    &--user {
      margin-left: 23px;
      @include flex();
    }

    &--language {
      margin-left: 43px;
      @include flex();
    }

    &__sign-in {
      margin-left: 12px;

      &--white {
        @include font-style($c-white, 14, 400, 0.8px);
      }

      &--black {
        @include font-style($c-black, 14, 400, 0.8px);
      }
    }

    &__language-more {
      margin-left: 8px;
    }
  }
}

.avatar-path {
  @include circle(30px);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
